import { useQuery } from 'react-query';
import { getSalesTaxTableByIndex } from '../../../../../../services/ReportService';

export const useTableTax = ({ id, params, page }) => {
  const { data, isFetching, isError, error, refetch, ...others } = useQuery(
    ['table-tax', page, params],
    () => getSalesTaxTableByIndex({ id, params, page }),
    {
      placeholderData: [],
      keepPreviousData: true,
    }
  );

  return {
    data,
    totalPages: data.total_pages,
    loading: isFetching,
    error: isError,
    errorObject: error,
    refetch,
    ...others,
  };
};
